import { ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Req, Query} from '@nestjs/common';
import { VillageService } from './village.service';
import { getmandalDTO, searchDto, VillageDTO, VillageStatusDTO } from './dto/village.dto';
import { errorHandler} from '@gtpl/shared-utils/error-messages';
import { VillageIdRequest,villageCodeRequest, VillageNameRequest } from './dto/villagename.request';
import { VillageResponseModel } from './dto/village-response.model';
import { AllVillageResponseModel, searchResponseModel } from './dto/all-village-response-model';
import { VillageStatusWiseResponseModel } from './dto/village-status-response.model';

@ApiTags('Village')
@Controller('village')
export class VillageController {
  constructor(
    private villageService: VillageService
  ){}

 
  @Post('/createVillage')
  @ApiQuery({name:'apiVersion'})
  async createVillage(@Query() queryParams,@Body() villageDto:VillageDTO,isUpdate:boolean=false,@Req() request:Request): Promise<VillageResponseModel> {
    try {
      return await this.villageService.createVillage(queryParams,villageDto, false,request);
    } catch (error) {
      return errorHandler(VillageResponseModel, error);
    }
  }
   
  @Post('/updateVillage')
  @ApiQuery({name:'apiVersion'})
  async updateVillage(@Query() queryParams,@Body() villageDto: VillageDTO,@Req() request:Request): Promise<VillageResponseModel> {
    try {
      return await this.villageService.createVillage(queryParams,villageDto, true,request);
    } catch (error) {
      return errorHandler(VillageResponseModel, error);
    }
  }

  @Post('/getAllVillages')
  @ApiQuery({name:'apiVersion'})
  async getAllVillages(@Query() queryParams,@Req() request:Request): Promise<AllVillageResponseModel> {
    try {
      return await this.villageService.getAllVillages(queryParams,request);
    } catch (error) {
      return errorHandler(AllVillageResponseModel, error);
    }
  }

  @Post('/getVillageByVillageName')
  @ApiQuery({name:'apiVersion'})
  async getVillageByVillageName(@Query() queryParams, @Body() villageNameRequest: VillageNameRequest,@Req() request:Request): Promise<VillageResponseModel> {
    try {
      return await this.villageService.getVillageByVillageName(queryParams,villageNameRequest.villageName,request);
    } catch (error) {
      return errorHandler(VillageResponseModel, error);
    }
  }

  @Post('/getVillageByVillageId')
  @ApiQuery({name:'apiVersion'})
  async getVillageByVillageId(@Query() queryParams,@Body() villageIdRequest: VillageIdRequest,@Req() request:Request): Promise<VillageResponseModel> {
    try {
      return await this.villageService.getVillageByVillageId(queryParams,villageIdRequest.Id,request);
    } catch (error) {
      return errorHandler(VillageResponseModel, error);
    }
  }

  @Post('/getAllActiveVillages')
  @ApiQuery({name:'apiVersion'})
  async getAllActiveVillages(@Query() queryParams,@Req() request:Request): Promise<AllVillageResponseModel> {
    try {
      return await this.villageService.getAllActiveVillages(queryParams,request);
    } catch (error) {
      return errorHandler(AllVillageResponseModel, error);
    }
  }

  @Post('/getActiveVillageCount')
  @ApiQuery({name:'apiVersion'})
  async getActiveVillageCount(@Query() queryParams,@Req() request:Request): Promise<VillageStatusWiseResponseModel> {
    try {
      return await this.villageService.getActiveVillageCount(queryParams,request);
    } catch (error) {
      return errorHandler(VillageStatusWiseResponseModel, error);
    }
  }

  @Post('/updateVillageStatus')
  @ApiQuery({name:'apiVersion'})
  async updateVillageStatus(@Query() queryParams,@Body() villageStatusDto: VillageStatusDTO,@Req() request:Request): Promise<VillageResponseModel> {
    try {
      return await this.villageService.updateVillageStatus(queryParams,villageStatusDto, request);
    } catch (error) {
      return errorHandler(VillageResponseModel, error);
    }
  }

  @Post('/searchPlaceByMandalId')
  @ApiQuery({name:'apiVersion'})
  async getVillagesByMandalId(@Query() queryParams,@Body() getmandalDTO:getmandalDTO,request: Request): Promise<searchResponseModel> {
      try {
          return await this.villageService.getVillagesByMandalId(queryParams,getmandalDTO,request);
      } catch (error) {
          return errorHandler(searchResponseModel, error);
      }
  }

  @Post('/searchPlace')
  @ApiQuery({name:'apiVersion'})
  public async getSearchPlace(@Query() queryParams, @Body() searchDto:searchDto, @Req() request:Request): Promise<searchResponseModel> {
    try {
      return await this.villageService.getSearchPlace(queryParams,searchDto,request);
    } catch (error) {
      return errorHandler(searchResponseModel, error);
    }
  }

}
